import React, { FC, useEffect } from 'react';

import Text from '~components/atoms/Text';

import ActionButton from '~components/atoms/ActionButton';

import combinedActions from '~redux/combinedActions';

import { useAppDispatch, useAppSelector } from '~redux/hooks';

import SummaryPDF from './SummaryPDF';

import * as SummaryStyles from './_GoldConversionSummary.module.scss';
import { GoldConversionStatusEnum } from '~utils/enums';

const GoldConversionSummary: FC = () => {
    const dispatch = useAppDispatch();

    const conversionFinalDraftsSummary = useAppSelector(state => state.gold.goldConversionFinalDraftsSummary);

    const goldConversionDraftId = useAppSelector(state => state.gold.goldConversionDraftId);

    useEffect(() => {
        if (!goldConversionDraftId?.draftId) return;

        dispatch(
            combinedActions.goldGetGoldConversionFinalDraftsSummaryAttempt({
                id: goldConversionDraftId.draftId,
            })
        );
    }, [dispatch, goldConversionDraftId?.draftId]);

    const summaryTable = [
        {
            label: 'Conversion Status',
            value: GoldConversionStatusEnum[conversionFinalDraftsSummary.conversionStatus],
        },
        {
            label: 'Region Name',
            value: conversionFinalDraftsSummary.regionName,
        },
        {
            label: 'Branch Name',
            value: conversionFinalDraftsSummary.branchName,
        },
        {
            label: 'Branch Code',
            value: conversionFinalDraftsSummary.branchCode,
        },
        {
            label: 'Name of Customer/Company Firm/Association',
            value: conversionFinalDraftsSummary.customerName,
        },
        {
            label: 'Identification No.',
            value: conversionFinalDraftsSummary.identificationNo,
        },
        {
            label: 'CIF No.',
            value: conversionFinalDraftsSummary.cifNo,
        },
        {
            label: 'Quantity',
            value: `${conversionFinalDraftsSummary.quantity} pcs`,
        },
        {
            label: 'Product Converted',
            value: conversionFinalDraftsSummary.targetProductName,
        },
        {
            label: 'Conversion Fee',
            value: `RM ${Number(
                conversionFinalDraftsSummary.conversionFee
            ).toFixed(2)}`,
        },
    ];

    const productTableHeader = [
        'Product Name',
        'Price per gram (MYR)',
    ];

    const handleSubmitForApproval = () => {
        dispatch(
            combinedActions.goldCreateGoldConversionAttempt({
                draftId: goldConversionDraftId.draftId,
            })
        );
    };

    return (
        <div className={SummaryStyles.container}>
            <table className={SummaryStyles['summary-table']}>
                <tbody>
                    {summaryTable.map((item, index) => (
                        <tr key={index}>
                            <td>{item.label}</td>

                            <td
                                data-testid={
                                    item.label === 'Quantity'
                                        ? 'transaction-summary-quantity'
                                        : undefined
                                }
                            >
                                : {item.value ?? ''}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            <div className={SummaryStyles['product-container']}>
                <Text
                    label='Description'
                    isBold
                />

                <table>
                    <tbody>
                        <tr>
                            {productTableHeader.map((item, index) => (
                                <td key={index}>
                                    {item}
                                </td>
                            ))}
                        </tr>

                        {conversionFinalDraftsSummary.description?.map(
                            (item, index) => (
                                <tr key={index}>
                                    <td>
                                        {item.productName}
                                    </td>

                                    <td>
                                        {Number(item.pricePerGram).toFixed(2)}
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>

            <div className={SummaryStyles['button-container']}>
                <SummaryPDF />

                <ActionButton
                    testId='createTransactionDraftSummary-backToForm-button'
                    label='Back to Form'
                    onClick={() =>
                        dispatch(combinedActions.goldSetIsFormFilled(false))
                    }
                />

                <ActionButton
                    testId='createTransaction-submitApproval-button'
                    label='Submit for Approval'
                    onClick={handleSubmitForApproval}
                />
            </div>
        </div>
    );
};

export default GoldConversionSummary;
